import { useEffect, useState } from 'react';
import type { IconModule, IconType } from '../index.types';

export function useDynamicIcon(
	iconName: string,
	iconImportMap: Record<string, () => Promise<IconModule>>,
) {
	const [IconComponent, setIconComponent] = useState<IconType | null>(null);

	useEffect(() => {
		let isMounted = true;

		const importFunction = iconImportMap[iconName];

		if (importFunction) {
			importFunction()
				.then((module: IconModule) => {
					if (isMounted) {
						setIconComponent(() => module.default);
					}
				})
				.catch(() => {
					if (isMounted) {
						setIconComponent(null);
					}
				});
		} else {
			if (isMounted) {
				setIconComponent(null);
			}
		}

		return () => {
			isMounted = false;
		};
	}, [iconName, iconImportMap]);

	return IconComponent;
}
